export default {
  LIST: [
    {id: '0', label: 'Select option', value: 'Select option', disabled: true},
    {id: '1', label: 'Option one', value: 'Option one'},
    {id: '2', label: 'Option two', value: 'Option two'},
    {id: '3', label: 'Option three', value: 'Option three'},
    {id: '4', label: 'Option four', value: 'Option four'},
    {id: '5', label: 'Option five', value: 'Option five'},
    {id: '6', label: 'Option six', value: 'Option six'},
    {id: '7', label: 'Option seven', value: 'Option seven'},
    {id: '8', label: 'Option eight', value: 'Option eight'},
    {id: '9', label: 'Option nine', value: 'Option nine'},
    {id: '10', label: 'Option ten', value: 'Option ten'}
  ],
  NAMES: [
    {label: 'Select name', value: ''},
    {label: 'Howard', value: 'Howard'},
    {label: 'Robin', value: 'Robin'},
    {label: 'Fred', value: 'Fred'},
    {label: 'Gary', value: 'Gary'},
    {label: 'Richard', value: 'Richard'},
    {label: 'Sal', value: 'Sal'}
  ]
}
